export enum AuthTypes {
    UPDATE_AUTH = 'UPDATE_AUTH',
    UPDATE_PRIVILEGES = 'UPDATE_PRIVILEGES'
}

export enum AppTypes {}
